export default __webpack_public_path__ + "static/media/about1.a3480087.png";